import { configureStore } from '@reduxjs/toolkit';
import cartReducer, { cartFetch } from '../features/cartSlice';

const store = configureStore({
    reducer: {
        cart: cartReducer
    }
});

store.dispatch(cartFetch());

export default store;